import { Dispatch, SetStateAction, useState } from 'react';

import { AppointmentSearch, Timeslot } from '../booking.types';

export type Timeslots = {
  slots: AppointmentSearch[];
  setSlots: Dispatch<SetStateAction<AppointmentSearch[]>>;
  selectedTimeslot: Timeslot | null;
  setSelectedTimeslot: Dispatch<SetStateAction<Timeslot | null>>;
};

export const useTimeslots = (): Timeslots => {
  const [slots, setSlots] = useState<AppointmentSearch[]>([]);
  const [selectedTimeslot, setSelectedTimeslot] = useState<Timeslot | null>(null);

  return {
    slots,
    setSlots,
    selectedTimeslot,
    setSelectedTimeslot,
  };
};
